import React from 'react'
import { debounce } from 'lodash'

import { isEmpty } from 'helpers/utils'

const scrollingCallback = (domClassString, dependencyArray) => () => {
  if (!isEmpty(dependencyArray)) {
    const scrollToComponent = require('react-scroll-to-component')
    const domElement = document.querySelector(domClassString)
    domElement && scrollToComponent(domElement)
  }
}

/**
 * This effect and ref helps scrolling elements only after 0.5s of no form fields interaction.
 */
export const useDebouncedScrollEffect = (domClassString, dependencyArray, debounceTimer = 500) => {
  const debouncedCallback = React.useRef(null)
  React.useEffect(() => {
    debouncedCallback.current && debouncedCallback.current.cancel()
    debouncedCallback.current = debounce(
      scrollingCallback(domClassString, dependencyArray),
      debounceTimer
    )
    debouncedCallback.current()
  }, [...dependencyArray, debouncedCallback, scrollingCallback])
}

/**
 * This effect scrolls to element as soon as being executed
 */
export const useScrollEffect = (domClassString, dependencyArray) => {
  React.useEffect(() => {
    scrollingCallback(domClassString, dependencyArray)()
  }, [...dependencyArray, scrollingCallback])
}
